export enum WEIGHT_VALUES {
	LBS = 'Lbs',
	KG = 'Kg',
}

export enum HEIGHT_VALUES {
	FT = 'Ft',
	CM = 'Cm',
}

export enum GENDER_VALUES {
	FEMALE = 'female',
	MALE = 'male',
}
